import { type PricingOption } from '@hungryroot/rest';
import { usePricingServiceCustomerContainerPriceOptions } from '../../hooks/usePricingServiceCustomerContainerPriceOptions';
import { EditServingSizeStepperModal } from '../EditServingSizeStepperModal/EditServingSizeStepperModal';

function getQuantity(option: PricingOption) {
  if (option.TIERED !== null) {
    return option.TIERED.quantity;
  }

  if (option.SKU_QUANTITY !== null) {
    return option.SKU_QUANTITY.quantity;
  }

  return option.RECIPE_QUANTITY.quantity;
}

function getPricePerServing(option: PricingOption) {
  if (option.TIERED !== null) {
    return option.TIERED.price_per_serving;
  }

  if (option.SKU_QUANTITY !== null) {
    return option.SKU_QUANTITY.price_per_serving;
  }

  return option.RECIPE_QUANTITY.price_per_serving;
}

function getMaxPricePerServing(option: PricingOption) {
  if (option.TIERED !== null) {
    return option.TIERED.max_price_per_serving;
  }

  if (option.SKU_QUANTITY !== null) {
    return option.SKU_QUANTITY.price_per_serving;
  }

  return option.RECIPE_QUANTITY.price_per_serving;
}

type OtherGroceriesModalProps = {
  heading: string;
  onDismiss: () => void;
  initialValue?: number;
  customerId: number;
  isOpen: boolean;
  containerId: number;
  onActionClick: (value: string) => void;
};

export const OtherGroceriesModal = (props: OtherGroceriesModalProps) => {
  const {
    heading,
    onDismiss,
    initialValue,
    customerId,
    isOpen,
    containerId,
    onActionClick,
  } = props;

  const { data, isLoading } = usePricingServiceCustomerContainerPriceOptions({
    customerId,
    containerId,
  });

  if (isLoading || !data) {
    return null;
  }

  const options = data?.pricing_options.map((option) => {
    // hardcoding this pricing configuration for now until we need to support multiple
    // pricing configurations
    return {
      label: option.name,
      value: String(getQuantity(option)),
      pricePerServing: String(getPricePerServing(option)),
      maxPricePerServing: String(getMaxPricePerServing(option)),
    };
  });

  return (
    <EditServingSizeStepperModal
      initialValue={initialValue}
      isOpen={isOpen}
      onDismiss={onDismiss}
      isLoading={isLoading}
      onActionClick={onActionClick}
      heading={heading}
      options={options}
    />
  );
};
